export default __webpack_public_path__ + "static/media/unsplash_Vd7YrLIJqYI.99c718ad.png";